
    import {
        computed,
        defineComponent,
        unref,
        type PropType,
    } from 'vue';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import CheckBoxInputList from '@ve/components/inputs/CheckBoxInputList.vue';
    import { ExWindow } from '@fr/vue/types';
    import TextCommon from '@ve/components/inputs/TextCommon.vue';
    import { PrepaymentItem } from '../lib/getPrepaymentsList';

    declare let window: ExWindow;

    export default defineComponent({
        name: 'PrepaymentsFilter',
        components: {
            CheckBoxInput,
            CheckBoxInputList,
            TextCommon,
        },
        props: {
            prepaymentsList: {
                type: Array as PropType<PrepaymentItem[]>,
                default: () => [],
            },
            selected: {
                type: Array as PropType<number[]>,
                default: () => [],
            },
            isMobile: {
                type: Boolean,
                default: false,
            },
        },
        emits: ['change'],
        setup(props, { emit }) {

            const isAnySelected = computed(() => props.selected.length === 0);

            const selectAny = () => {
                emit('change', []);
            };

            const onSelectionChange = (newSelected: number[]) => {
                emit('change', newSelected);
            };

            return {
                isAnySelected,
                selectAny,
                onSelectionChange,
            };
        },
    });
